import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as actions from 'global/actions/passwordActions';
import { useActions } from 'hooks/useActions';
import { useAppContext } from 'hooks/useContext';
import * as strings from './strings';
import apiErrors from 'api/apiErrors';
import { Container, Wrapper } from 'components/Layout/Layout';
import { ButtonsContainer, RectangleButton } from 'components/Button/RectangleButton';
import { Form } from 'components/FormComponents/FormComponents';
import {
  AuthPageBackgroundImage,
  AuthContainer,
  Heading,
  InputContainer,
  InputField,
  Icon,
  InfoText,
  AuthPageGradient,
} from '../LoginPage/styles';

export default React.memo(() => {
  const { loading, error, success } = useSelector((state) => state.managePassword);
  const { clearError, clearState, resetPassword } = useActions(actions);

  const [email, setEmail] = useState('');
  const { language } = useAppContext();

  useEffect(() => {
    return () => clearState();
  }, [clearState]);

  return (
    <Wrapper isNewPage>
      <AuthPageBackgroundImage>
        <AuthPageGradient />
      </AuthPageBackgroundImage>
      <Container column useZIndex="1">
        <AuthContainer>
          <Heading>{strings.header[language]}</Heading>
          <Form onChange={() => error && clearError()} onSubmit={() => resetPassword(email)}>
            <InputContainer hasError={error}>
              <Icon className="fa-solid fa-envelope" />
              <InputField
                type="text"
                hasError={error}
                value={email}
                placeholder={strings.emailPlaceholder[language]}
                disabled={success}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputContainer>
            <ButtonsContainer padding="20px 0 0">
              <RectangleButton type="submit" isAuthButton disabled={!email || success}>
                {strings.header[language]}
              </RectangleButton>
            </ButtonsContainer>
          </Form>
          {(error || success) && (
            <InfoText error={error} success={success}>
              {loading ? strings.loadingLabel[language] : ''}
              {apiErrors?.[error?.name]?.[language] ?? error?.[language] ?? error}
              {success ? strings.successLabel[language] : ''}
            </InfoText>
          )}
        </AuthContainer>
      </Container>
    </Wrapper>
  );
});
